import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'base64Image'
})
export class Base64ImagePipe implements PipeTransform {

  constructor(private domSanitizer: DomSanitizer) { }

  transform(base64Img: string): any {
    return this.domSanitizer.bypassSecurityTrustUrl(base64Img);
  }

}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/pipe/base64-image.pipe.ts